export function calculateEditorialCoverage(topics = [], lessons = []) {
  if (!topics.length) return null;
  const linked = new Set(lessons.filter(item => item.published).flatMap(item => item.noticeTopicIds || []));
  const covered = topics.filter(topic => linked.has(topic.id)).length;
  return { covered, total:topics.length, percentage:Math.round(covered / topics.length * 100) };
}

export function calculateMastery({ attempts = [], reviews = [] }) {
  if (!attempts.length) return 0;
  const accuracy = attempts.filter(item => item.correct).length / attempts.length * 100;
  const reviewRate = reviews.length ? reviews.filter(item => item.completed).length / reviews.length * 100 : 0;
  return Math.round(accuracy * .8 + reviewRate * .2);
}

